import React, { useEffect, useRef } from 'react';
import { moveBridge } from '../state/moveBridge';

// TouchControls — an on-screen movement joystick for touch devices (drag-to-look
// already works via pointer events; this adds locomotion, which was WASD-only).
// One thumb drives the stick (bottom-left); the other can drag anywhere else to
// look. Shown on touch devices, or forced with ?touch=1 for desktop testing.
const R = 52; // knob travel radius (px)

export default function TouchControls() {
  const baseRef = useRef();
  const knobRef = useRef();
  const pid = useRef(null);

  const set = (nx, ny) => {
    if (knobRef.current) knobRef.current.style.transform = `translate(${nx}px, ${ny}px)`;
    moveBridge.x = nx / R;
    moveBridge.y = -ny / R;            // pushing UP the screen = forward
  };
  const update = (e) => {
    const r = baseRef.current.getBoundingClientRect();
    const dx = e.clientX - (r.left + r.width / 2);
    const dy = e.clientY - (r.top + r.height / 2);
    const len = Math.hypot(dx, dy) || 1;
    const m = Math.min(len, R);
    set(dx / len * m, dy / len * m);
  };
  const onDown = (e) => { pid.current = e.pointerId; e.currentTarget.setPointerCapture(e.pointerId); update(e); };
  const onMove = (e) => { if (pid.current === e.pointerId) update(e); };
  const onUp = (e) => { if (pid.current !== e.pointerId) return; pid.current = null; set(0, 0); };
  // Taken away mid-push (a cutscene takes the screen): let go of the stick, or
  // the last push would keep walking you once it hands the view back.
  useEffect(() => () => { moveBridge.x = 0; moveBridge.y = 0; }, []);

  return (
    <div
      ref={baseRef}
      onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerCancel={onUp}
      style={{
        // Above the player bar (components/PlayerBar publishes its height).
        position: 'fixed', left: 'max(22px, env(safe-area-inset-left))', bottom: 'calc(max(18px, env(safe-area-inset-bottom)) + var(--hud-player-h, 0px))',
        zIndex: 44, width: 128, height: 128,
        borderRadius: '50%', background: 'rgba(20,22,26,0.35)', border: '1px solid rgba(255,255,255,0.22)',
        touchAction: 'none', pointerEvents: 'auto', display: 'grid', placeItems: 'center',
        backdropFilter: 'blur(2px)', WebkitBackdropFilter: 'blur(2px)',
      }}
    >
      <div ref={knobRef} style={{
        width: 54, height: 54, borderRadius: '50%', background: 'rgba(255,255,255,0.65)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.4)', pointerEvents: 'none',
      }} />
    </div>
  );
}
